import { useEffect, useState } from "react"
import { useIntl } from "react-intl";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { TableData, TabStatus, UpgradeRequest } from "./MenteeTab.model";
import moment from "moment";

export const pageSize = 10;

export const useMenteeTab = ({ searchTerm }: any) => {
	const [upgradeRequests, setUpgradeRequests] = useState<TableData[]>();
	const [pagination, setPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);

	const { get } = useFetchWrapper();

	const intl = useIntl()

	const getRequests = async () => {

		setTabStatus(TabStatus.Loading);

		const response: HttpResponse<{ count: number, requests: UpgradeRequest[] }> = await get(`/user/upgrade-role/all?page=${pagination.page}&size=${pagination.size}&name=${searchTerm || ''}`);

		if (response.parsedBody) {
			const { requests, count } = response.parsedBody;
			setUpgradeRequests(requests.map((req: UpgradeRequest) => ({
				createdAt: moment(req.requestUpgradeRole.createdAt).format("DD MMM YYYY"),
				id: req.requestUpgradeRole.id,
				imageId: req.createdBy.imageId,
				name: `${req.createdBy.firstName} ${req.createdBy.lastName}`,
				status: req.requestUpgradeRole.status,
				userId: req.createdBy.userId
			})));
			setPagination({ ...pagination, total: count });
			setTabStatus(TabStatus.Loaded);
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	const onChangePagination = (page: number) => {
		setPagination({ ...pagination, page });
	}

	useEffect(() => {
		if (pagination.page > 1) {
			setPagination({ ...pagination, page: 1 });
		}
		else getRequests();
	}, [searchTerm]);

	useEffect(() => {
		getRequests();
		console.log(upgradeRequests)
	}, [pagination.page]);

	return {
		getRequests,
		onChangePagination,
		state: {
			pagination,
			tabStatus,
			upgradeRequests
		},
	}
}